import React from 'react';
import axios from 'axios';
import {Boton, Accion} from '../../comun/Index';
import Nuevo from './Nuevo';

class Listado extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      expandir:null
    }
  }

  expandir(id){
    const {expandir} = this.state;
    if (expandir !== id){
      this.setState({expandir:id});
    } else {
      this.setState({expandir:null});
    }
  }

  cambiarEstado(item, estado){
    /* ENVIAR EL CAMBIO DE ESTADO Y ACTUALIZAR */
  }
  getTipo(tipo){
    switch (tipo) {
      case 1:
        return("Mesa de entrada");
      case 2:
        return("Agente");
      case 3:
        return("Autoridad");
      case 4:
        return("Administrador");
      default:
        return("Desconocido");
    }
  }

  reestablecer(id){
    if (window.confirm("¿Seguro desea reestablecerle la contraseña?")){
      this.props.reestablecer(id)
    }
  }

  render(){
    const {expandir} = this.state;
    const {usuarios} = this.props;
    return(
      <div className="Lista">
        {usuarios.map((item, index) => {
          return(
            <div
              key={index}
              className="Item"
              style={{backgroundColor:index%2===1?'#e3e3e3':'#f0f0f0', color:!item.activo?'grey':null}}
            >
              <div className="Detalles">
                <div style={{display:'flex', flexDirection:'row', alignItems:'flex-end'}}>
                  <Accion
                    icono={expandir === index ? 'keyboard_arrow_up': 'keyboard_arrow_down'}
                    ayuda="Expandir"
                    backgroundColor="lightgrey"
                    disabled={false}
                    onClick={() => this.expandir(index)}
                  />
                  {item.nombre} &nbsp;
                  <i style={{fontSize:11, marginBottom:2}}>{this.getTipo(item.tipo)}</i>
                </div>
                <div className="Acciones">
                  <span style={{fontSize:12}}>{item.activo?'activo':'inactivo'}</span>
                  <Accion
                    icono="power_settings_new"
                    ayuda=""
                    backgroundColor={item.activo?'green':'red'}
                    disabled={false}
                    onClick={() => this.props.cambiarEstado(item.id, !item.activo)}
                  />
                  <Accion
                    icono="edit"
                    ayuda="Editar"
                    backgroundColor="#00a5e5"
                    disabled={false}
                    onClick={() => this.props.editar(index)}
                  />
                  <Accion
                    icono="vpn_key"
                    ayuda="Blanquear"
                    backgroundColor="orange"
                    disabled={false}
                    onClick={() => this.reestablecer(item.id)}
                  />
                </div>
              </div>
              {expandir === index &&
                <div className="Preguntas">
                  <p style={{margin:3}}>
                    Usuario: <strong>{item.user}</strong>
                  </p>
                  <p style={{margin:3}}>
                    Localidad: <strong>{item.localidad}</strong>
                  </p>
                  <p style={{margin:3}}>
                    eMail: <strong>{item.mail}</strong>
                  </p>
                  <p style={{margin:3}}>
                    Doc.: <strong>{item.documento}</strong>
                  </p>
                  <p style={{margin:3}}>
                    ultima conexion: <strong>{item.ultima}</strong>
                  </p>
                  <p style={{margin:3}}>
                    Área: <strong>{item.area}</strong>
                  </p>
                </div>
              }
            </div>
          )
        })}
      </div>
    );
  }
}

const getLocalidades = function(){
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + '/localidades/listar/')
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve(res.data.localidades)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

const getAreas = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/areas/todos/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.areas)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

export default class Usuarios extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      usuarios:[],
      localidades:[],
      areas:[],
      showModal:false,
      datosModal:{}
    }
  }

  componentDidMount(){
    getLocalidades()
    .then((localidades) => {
      getAreas()
      .then((areas) => {
        this.setState({localidades, areas});
        this.actualizar();
      })
    })
    .catch((error) => {
      alert("Ocurrió un error");
      console.log(error)
    })
  }



  async actualizar(){
    this.setState({usuarios:[]})
    this.setState({datosModal:{},showModal:false});
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    const url = localStorage.getItem('apiUrl') + '/users/admin/listar';
    axios.get(url, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.setState({usuarios:res.data.usuarios})
      } else {
        alert(res.data.error)
      }
    })
    .then(() => {
      this.setState({
        datosModal:{},
        showModal:false
      })
    })
    .catch((err) => {
      console.log(err);
    })
  }

  nuevo(){
    this.setState({datosModal:{},showModal:true});
  }

  editar(index){
    this.setState({datosModal:this.state.usuarios[index]});
    this.setState({showModal:true});
  }

  guardar(datos){
    const url = localStorage.getItem('apiUrl') + '/users/admin/nuevo';
    const consulta={datos};
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, consulta, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        this.setState({showModal:false,datosModal:{}});
        this.actualizar();
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }

  reestablecer(id){
    const url = localStorage.getItem('apiUrl') + '/users/admin/cambiarpass';
    const consulta={idUser:id};
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, consulta, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        alert("Contraseña reestablecida\nLa nueva contraseña es el numero de documento")
        this.actualizar()
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      alert("Ocurrio un error");
      console.log(err);
    })
  }
  cambiarEstado(id_user, estado){
    const url = localStorage.getItem('apiUrl') + '/users/admin/cambiarestado';
    const consulta={id_user,estado};
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, consulta, config)
    .then((res) =>{
      console.log(res)
      if (res.data.status === "ok"){
        this.actualizar();
      } else {
        alert(res.data.error);
      }
    })
    .catch((err) => {
      console.log(err);
    })
  }

  render(){
    const {showModal, datosModal, usuarios, localidades, areas} = this.state;
    return(
      <div className="TramitesTodo">
        {showModal &&
          <Nuevo
            datos={datosModal}
            localidades={localidades}
            areas={areas}
            salir={() => {window.scrollTo(0,0);this.setState({showModal:false,datosModal:{}})}}
            guardar={(datos) => {window.scrollTo(0,0);this.guardar(datos)}}
          />
        }
        <h3>Usuarios</h3>
        <Listado
          usuarios={usuarios}
          editar={(index) => {window.scrollTo(0,0);this.editar(index)}}
          reestablecer={(id) => this.reestablecer(id)}
          cambiarEstado={(id,estado) => this.cambiarEstado(id, estado)}
        />
        <Boton
          backgroundColor="#00a5e5"
          titulo="Nuevo"
          onClick={() => {window.scrollTo(0,0);this.nuevo()}}
        />
      </div>
    );
  }
}
